import TitleTemplate from "../../../components/ui/common/template/TitleTemplate";
import PageTemplate from "../../../components/ui/common/template/PageTemplate";
import DiamondScope from "../../../components/ui/specialty/DiamondScope";
import WorkScopes from "../../../components/ui/specialty/WorkScopes";
import FTAOriginDeterTable from "../../../components/contents/specialty/consulting/fta/FTAOriginDeterTable";
import CenterDiv from "../../../style/styled-components/components/CenterDiv";
import FTAPrefTable from "../../../components/contents/specialty/consulting/fta/FTAPrefTable";
import UseBreakpoints from "../../../components/hooks/ui/UseBreakpoints";
import ContactPoints from "../../../components/ui/members/ContactPoints";
import { card } from "../../../style/styled-components/mixins";
import FTAImage from "../../../../src/resources/images/fta.jpg";
import img1 from "../../../resources/images/icon/7. FTA/1. FTA 컨설팅.png";
import img2 from "../../../resources/images/icon/7. FTA/2.1 인증수출자.png";
import img4 from "../../../resources/images/icon/7. FTA/3. 원산지증명서 발급대행.png";
import img5 from "../../../resources/images/icon/7. FTA/4. 원산지요건 확인.png";
import img6 from "../../../resources/images/icon/7. FTA/5. 형식적정성 확인.png";
import img7 from "../../../resources/images/icon/7. FTA/6. 원산지검증 조력서비스.png";
import img8 from "../../../resources/images/icon/7. FTA/7. FTA 사후관리.png";
import img9 from "../../../resources/images/icon/7. FTA/8. 각 협정별 법률 자문_rev.png";
import styled from "styled-components";

// 근거: 기존 fta_countries_rev.png 세계지도의 협정 라벨. 지도 이미지 대신 권역별로 묶어 보여 준다.
const ftaRegions = [
  { region: "아시아·오세아니아", agreements: ["한-중국", "한-ASEAN", "한-인도", "한-호주", "한-뉴질랜드", "RCEP"] },
  { region: "미주", agreements: ["한-미", "한-캐나다", "한-중미", "한-콜롬비아", "한-페루", "한-칠레"] },
  { region: "유럽·기타", agreements: ["한-EU", "한-영국", "한-EFTA", "한-터키"] },
];

const FTAPage = () => {
  const breakpoints = UseBreakpoints();
  return (
    <PageTemplate
      large
      image={FTAImage}
      title="FTA"
      phrase="적법한 FTA 적용 및 사후검증 대리를 통하여 기업의 FTA 활용을 극대화합니다."
      description="우리나라와 자유무역협정을 체결하는 국가가 늘어남에 따라 수출입 시에 그
      혜택을 적법하게 적용받는 것이 중요하게 되었습니다. 각 FTA 협정별 원산지
      요건 충족여부, 관련 서류 형식적정성 등에 대한 진단 서비스를 제공하며,
      원산지 사후검증 시 풍부한 검증 경험을 보유하고 있는 FTA 전문가가 기업
      RISK를 최소화합니다."
    >
      <TitleTemplate
        title="FTA 체약국"
        noImage
        subHeader="협정별로 상이한 기준에 맞춰 정확한 FTA의 적용을 실현합니다."
      />
      <FTACountriesGrid breakpoints={breakpoints}>
        {ftaRegions.map((r) => (
          <div key={r.region}>
            <b>{r.region}</b>
            <ul>
              {r.agreements.map((a) => (
                <li key={a}>{a}</li>
              ))}
            </ul>
          </div>
        ))}
      </FTACountriesGrid>
      <Note>※ 주요 협정만 표시했습니다. 2026년 10월 기준 발효 협정 전체(23건·60개국)는 아래 표를 참고하세요.</Note>
      <CenterDiv>
        <FTAPrefTable />
      </CenterDiv>
      <TitleTemplate title="원산지 결정기준" noImage />
      <CenterDiv>
        <FTAOriginDeterTable />
      </CenterDiv>
      <TitleTemplate
        title="업무 범위"
        noImage
        subHeader="복잡하고 어려운 FTA의 내용을 고객사 거래 상황에 맞추어 정확하게 수행합니다."
      />
      <WorkScopes
        contents={[
          { title: "FTA 컨설팅", icon: img1 },
          { title: "인증수출자", icon: img2 },
          { title: "원산지증명서 발급대행", icon: img4 },
          { title: "원산지요건 확인", icon: img5 },
          { title: "형식적정성 확인", icon: img6 },
          { title: "원산지 검증 조력서비스", icon: img7 },
          { title: "FTA 사후관리", icon: img8 },
          { title: "각 협정별 법률 자문", icon: img9 },
        ]}
      />
      <TitleTemplate
        title="Strength"
        noImage
        subHeader="A-One만의 장점으로 고객을 힘껏 서포트해 나가겠습니다."
      />
      <DiamondScope
        contents={[
          {
            title: "Cooperation",
            text: "유관기관과의 협력을 통한 원활한 FTA 이슈 해결",
          },
          {
            title: "Professional Expert",
            text: "전문지식을 보유한 FTA 전문가들의 법률 자문 제공",
          },
          {
            title: "Experience",
            text: "풍부한 경험을 통한 전문 FTA 서비스 제공",
          },
          {
            title: "Consulting",
            text: "산업별, 체결국가별 발생 가능한 FTA Risk 진단",
          },
        ]}
      />
      <TitleTemplate
        title="Contact Point"
        noImage
        subHeader="언제나 믿고 맡길 수 있는 최고의 멤버와 함께합니다."
      />
      <ContactPoints members={["jskim"]} />
    </PageTemplate>
  );
};
export default FTAPage;
const FTACountriesGrid = styled.div`
  display: grid;
  grid-template-columns: ${({ breakpoints }) => (breakpoints.md ? "repeat(3, minmax(0, 1fr))" : "minmax(0, 1fr)")};
  gap: 1rem;
  & > div {
    ${card}
    position: relative;
    overflow: hidden;
    padding: 1.5rem 1.4rem 1.4rem;
    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      background: linear-gradient(90deg, ${({ theme }) => theme.colors.accent}, ${({ theme }) => theme.colors.dark});
    }
    & > b {
      font-size: 1.1rem;
      font-weight: 800;
      letter-spacing: -0.01em;
      color: ${({ theme }) => theme.colors.dark};
    }
    & > ul {
      list-style: none;
      margin: 0.9rem 0 0;
      padding: 0;
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 0.5rem 1rem;
      font-size: 0.95rem;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.monotone.dark};
      & > li {
        position: relative;
        padding-left: 0.8em;
        &::before {
          content: "•";
          position: absolute;
          left: 0;
          color: ${({ theme }) => theme.colors.accent};
        }
      }
    }
  }
`;
const Note = styled.p`
  margin: 1rem 0 0;
  font-size: 0.95em;
  color: ${({ theme }) => theme.colors.foreground.dimmed};
`;
